import React, {useState} from "react";
import PropTypes from 'prop-types';

function Question({question}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div className="mb-2">
      <div className="font-medium rounded-sm text-lg px-2 py-3 flex text-gray-800 flex-row-reverse mt-2 cursor-pointer text-black bg-white hover:bg-white" onClick={() => setExpanded(!expanded)}>
        <div className="flex-auto">{question.q}</div>
        <div className="px-2 mt-1">
          <div>
            {expanded ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                   className="feather feather-chevron-up w-5 h-5">
                <polyline points="18 15 12 9 6 15"/>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                   strokeLinejoin="round" className="feather feather-chevron-down w-5 h-5">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            )}
          </div>
        </div>
      </div>
      <div className="px-5 py-3 text-justify text-left text-gray-800 mb-5 bg-white prose max-w-none" style={{display: expanded ? 'block' : 'none'}} dangerouslySetInnerHTML={{__html: question.a}}/>
    </div>
  );
}

Question.propTypes = {
  question: PropTypes.object
}

export default Question;
